import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('mocv_token');
    if (token) {
      authAPI.getCurrentUser(token)
        .then(userData => {
          setUser({ ...userData, token });
        })
        .catch(() => {
          localStorage.removeItem('mocv_token');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const data = await authAPI.login(email, password);
    localStorage.setItem('mocv_token', data.token);
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('mocv_token');
    setUser(null);
  };

  const isSuperadmin = () => {
    return user?.role === 'superadmin';
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isSuperadmin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
